import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { presetsApi } from '../../api/presets';
import { GQLArgs } from '../../types';

type CreatePresetResponse = { createPreset: any };

export const useMutationCreatePreset = (args?: GQLArgs<CreatePresetResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<CreatePresetResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { name: string; content: string } }) => {
      setLoading(true);
      try {
        const res = await presetsApi.create({ name: variables.name, content: variables.content });
        const shaped: CreatePresetResponse = { createPreset: res.data };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('Preset has been created', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
